import Flickity from './../../externals/flickity/wwdevFlickity';

class Header {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-scope="header"]',
			navbar: '[data-scope="navbar"]',
			dropdown: '.dropdown',
			dropdownToggle: '.dropdown-toggle',
			dropdownHover: '.dropdown-hover',
			navLinkHover: '.nav-link-hover',
			search: '.search',
			clearSearch: '.search-clear',
			history: '[data-scope="history"]',
			searchInput: '.search-input',
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$navbar = $(this.config.navbar);

		this.$navbar.on('mouseenter', this.config.navLinkHover, () => this.hideOtherDropdowns());
		this.$navbar.on('mouseenter', this.config.dropdownHover, this.showDropdown.bind(this));
		this.$navbar.on('mouseleave', this.config.dropdownHover + '+ .dropdown-menu', this.hideDropdownOnLeave.bind(this));

		$(document).on('click', this.config.search, this.toggleSearch.bind(this));
		$(document).on('click', this.config.clearSearch, this.clearSearch.bind(this));
		$(document).on('click', '.page-backdrop', this.closeSearch.bind(this));
		$(document).on('click', this.config.history, this.doSearch.bind(this));

		$(document).on('shown.bs.dropdown', this.config.dropdownToggle, event => {
			let carousel = Flickity.data(
				$(event.currentTarget).closest(this.config.dropdown).find('.flickity-carousel')[0]
			);
			if (carousel) {
				carousel.resize();
			}
		});
	}

	showDropdown(event) {
		this.hideOtherDropdowns(event);
		this.getDropdown($(event.currentTarget)).show();
	}

	hideOtherDropdowns(event = null) {
		let current = event ? event.currentTarget : event;
		this.$scope.find(this.config.dropdownToggle).each((index, element) => {
			if (element !== current) {
				this.getDropdown($(element)).hide();
			}
		});
	}

	hideDropdownOnLeave(event) {
		let dropdown = $(event.currentTarget).closest(this.config.dropdown).find(this.config.dropdownHover);
		this.getDropdown(dropdown).hide();
	}

	getDropdown(dropdown) {
		return bootstrap.Dropdown.getOrCreateInstance(dropdown);
	}

	toggleSearch(event) {
		event.preventDefault();
		event.stopPropagation();

		let $search = $(this.config.search);
		if($search.data('open') == true) {
			this._closeSearch($search);
		} else {
			this._openSearch($search);
		}
	}

	_openSearch($search) {
		$search.addClass('active');
		$('body').addClass('overflow-hidden');
		$('.page-backdrop').addClass('show');
		$('.search-bar').addClass('show');
		$search.data('open', true);
	}

	_closeSearch($search) {
		$search.removeClass('active');
		$('body').removeClass('overflow-hidden');
		$('.page-backdrop').removeClass('show');
		$('.search-bar').removeClass('show');
		$search.data('open', false);
	}

	closeSearch(event) {
		$('body').removeClass('overflow-hidden');
		$('.page-backdrop').removeClass('show');
		$('.search-bar').removeClass('show');
		event.preventDefault();
		event.stopPropagation();
	}

	doSearch(event) {
		let $button = $(event.currentTarget);
		let search = $button.data('search');
		let $input = $(this.config.searchInput);
		$input.val(search);
		$input.trigger('keyup');
	}

	clearSearch(event) {
		let $searchInput = $(event.currentTarget).closest('form').find(this.config.searchInput);
		if ($searchInput.length > 0) {
			$searchInput.val('');
		}
	}
}

export default new Header;
